import Check from '@mui/icons-material/Check';
import { BaseModal } from '@src/common/components/BaseModal';
import { Button } from '@src/common/components/button/Button';
import { Divider } from '@src/common/components/Divider';
import { Stack } from '@src/common/components/Stack';
import { TextInput } from '@src/common/components/TextInput';
import { theme } from '@src/common/styles/Theme';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onClose: () => void;
  open: boolean;
  onSubmit: (invoiceNumber: string) => void;
}

export const FillAllInvoiceNumberModal = ({
  onClose,
  open,
  onSubmit,
}: Props) => {
  const { t } = useTranslation();
  const [invoiceNumber, setinvoiceNumber] = useState<string>('');
  return (
    <BaseModal
      title={t('fillAllInvoiceNumberModal.title')}
      subtitle={t('fillAllInvoiceNumberModal.subtitle')}
      open={open}
      onClose={onClose}
      marginBottom="0"
    >
      <TextInput
        style={{
          marginTop: theme.spacing['8'],
          marginBottom: theme.spacing['8'],
        }}
        value={invoiceNumber}
        onChange={(e) => setinvoiceNumber(e.target.value)}
        label={t('fillAllInvoiceNumberModal.invoiceNumber')}
      />
      <Divider style={{ marginBottom: theme.spacing['9'] }} />
      <Stack direction="row" justifyContent="end" gap={theme.spacing['3']}>
        <Button type="button" variant="outlined" onClick={onClose}>
          {t('fillAllInvoiceNumberModal.cancel')}
        </Button>
        <Button
          type="button"
          variant="contained"
          startIcon={<Check />}
          onClick={() => {
            onSubmit(invoiceNumber);
            setinvoiceNumber('');
            onClose();
          }}
        >
          {t('fillAllInvoiceNumberModal.setNumber')}
        </Button>
      </Stack>
    </BaseModal>
  );
};
